export const INPUT_PROPS = {
  min: 0
};
